<template>
<div class="home-container pb-5">
    <section class="d-flex align-items-center justify-content-between">
        <h2 class="after-extra-large-text font-weight-600">თასქები</h2>
        <secondaryButton buttonType="button" class="large-text font-weight-600" buttonWidth="max-content" paddingX="15px">
            <template v-slot:content>
                ახალი თასქი
            </template>
        </secondaryButton>
    </section>
    <section class="d-flex flex-column gap-3 align-items-start">
        <div :class="['d-flex', 'search-container', 'w-100']">
            <form class="custom-tasks-primary-search-container-form" @submit.prevent>
                <autoSubmittedInput :Vmodel="tasksFiltersInfoObj.search" indicator="modal-flyer-search-input" @valueUpdated="updateTasksSearch"/>

                <fieldset class="d-flex gap-3 align-items-center" ref="taskTypesGetterButtonsWrappper">
                    <h6 class="standard-text font-weight-600">ტიპი:</h6>
                    <primaryButtonComponent v-for="(data, i) of taskTypesGetterButtonsArray" buttonType="button" :mode="data.mode" @click="getterButtonsSubmitHandler({'taskstype': data.routeSetValue})" class="large-text font-weight-600" buttonWidth="200px" paddingY="10px">
                        <template v-slot:content>
                            <p style="width: max-content;">
                                {{ data.content }}
                            </p>
                        </template>
                    </primaryButtonComponent>
                </fieldset>
                <fieldset class="d-flex gap-3 align-items-center" ref="taskTypesGetterButtonsWrappper">
                    <h6 class="standard-text font-weight-600">ფილტრები:</h6>
                    <primaryButtonComponent v-for="(data, i) of taskPrioritiesGetterButtonsArray" buttonType="button" :mode="data.mode" @click="getterButtonsSubmitHandler({'taskspriority': data.routeSetValue})" class="large-text font-weight-600" buttonWidth="200px" paddingY="10px">
                        <template v-slot:content>
                            <p style="width: max-content;">
                                {{ data.content }}
                            </p>
                        </template>
                    </primaryButtonComponent>
                </fieldset>

                <!-- <button type="submit" class="extra-light-text extra-green-color ms-2" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button> -->
            </form>
            <!-- <excelFileDownloadComponent @igniteDownload="igniteDownload" excelFileName="mobilisation" :namesArray="['supporters', 'employees']" :jsonToExcelArray="jsonToExcelArray" :downloadInAction="downloadInAction"/> -->
        </div>
    </section>
    <section class="d-flex flex-column gap-3 align-items-start">
        <div :class="['d-flex', 'search-container', 'w-100']">
            <form class="search-container-form" @submit.prevent="submitTaskWorkersFilters()">
                <fieldset class="filters-wrapper">
                    <input v-model="taskWorkersFiltersInfoObj.search" name="search-input" id="search-input" type="text" class="primary-input extra-light-text" placeholder="ძებნა"/>
                    <datePicker :datePickerMode="1" :rangeVmodelKeeper="taskWorkersFiltersInfoObj.date" indicator="dateFilter" :isRequired="false" @update="handleDate"/>

                    <Multiselect ref="cityID" v-model="taskWorkersFiltersInfoObj.cityID" :options="this.taskWorkersFiltersAreaMultiselectArray[1].options" :mode="this.taskWorkersFiltersAreaMultiselectArray[1].mode"
                        :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                        :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 2, true, true, taskWorkersFiltersAreaMultiselectArray, taskWorkersFiltersInfoObj)" @deselect="() => blockNextMultiselects(2, taskWorkersFiltersAreaMultiselectArray, taskWorkersFiltersInfoObj)" @clear="() => blockNextMultiselects(2, taskWorkersFiltersAreaMultiselectArray, taskWorkersFiltersInfoObj)"
                        class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.taskWorkersFiltersAreaMultiselectArray[1].placeholder" :disabled="this.taskWorkersFiltersAreaMultiselectArray[1].isDisabled" insert/>
                    <Multiselect ref="regionID" v-model="taskWorkersFiltersInfoObj.regionID" :options="this.taskWorkersFiltersAreaMultiselectArray[2].options" :mode="this.taskWorkersFiltersAreaMultiselectArray[2].mode"
                        :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                        :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 3, true, true, taskWorkersFiltersAreaMultiselectArray, taskWorkersFiltersInfoObj)" @deselect="() => blockNextMultiselects(3, taskWorkersFiltersAreaMultiselectArray, taskWorkersFiltersInfoObj)" @clear="() => blockNextMultiselects(3, taskWorkersFiltersAreaMultiselectArray, taskWorkersFiltersInfoObj)"
                        class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.taskWorkersFiltersAreaMultiselectArray[2].placeholder" :disabled="this.taskWorkersFiltersAreaMultiselectArray[2].isDisabled" insert/>
                    <Multiselect ref="districtID" v-model="taskWorkersFiltersInfoObj.districtID" :options="this.taskWorkersFiltersAreaMultiselectArray[3].options" :mode="this.taskWorkersFiltersAreaMultiselectArray[3].mode"
                        :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                        :hideSelected="true" locale="ge"
                        class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.taskWorkersFiltersAreaMultiselectArray[3].placeholder" :disabled="this.taskWorkersFiltersAreaMultiselectArray[3].isDisabled" insert/>                    
                    <button type="submit" class="extra-light-text extra-green-color ms-2" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button>
                </fieldset>
            </form>
            <!-- <excelFileDownloadComponent @igniteDownload="igniteDownload" excelFileName="mobilisation" :namesArray="['supporters', 'employees']" :jsonToExcelArray="jsonToExcelArray" :downloadInAction="downloadInAction"/> -->
        </div>
    </section>
    <section class="d-flex flex-column gap-3 align-items-center" style="margin-top: -0.7em;">
      
      <div class="border-radius-20 w-100" style="background-color: var(--secondary-background-color); border-radius: 25px;">
        <div class="common-table-container common-scrollbar mt-2">
          <table class="common-tablee">
            <thead>
              <tr>
                <th></th>
                <th class="light-text light-blue-color">სახელი გვარი</th>
                <th class="light-text light-blue-color">ასაკი</th>
                <th class="light-text light-blue-color">ტელეფონი</th>
                <th class="light-text light-blue-color">მისამართი</th>
                <th class="light-text light-blue-color">ელ-ფოსტა</th>
                <th class="light-text light-blue-color">დამ.თარიღი</th>
                <th class="light-text light-blue-color">ჯგუფი</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(taskWorker, i) of [1,1,1,]">
                <tr class="light-black-color light-text">
                    <td class="d-flex justify-content-start" style="width: min-content;">
                        <img v-if="false" src="" alt="profile photo" style="width: 33px; height: 33px; border-radius: 50%;">
                        <div v-else style="width: 33px; height: 33px; border-radius: 50%; background-color: var(--light-blue);"></div>
                    </td>
                    <td><p>luka</p></td>
                    <td><p>luka</p></td>
                    <td><p>luka</p></td>
                    <td><p>luka</p></td>
                    <td><p>luka</p></td>
                    <td><p>luka</p></td>
                    <td><p>luka</p></td>
                    <td style="padding: 0; width: min-content;">
                        <primaryButtonComponent buttonWidth="max-content" class="extra-light-text" paddingY="8px" paddingX="10px" :mode="2">
                            <template v-slot:content>
                                კომენტარი
                            </template>
                        </primaryButtonComponent>
                    </td>
                    <td style="padding: 0; width: min-content;">
                        <div class="d-flex gap-2 align-items-center justify-content-end" style="width: min-content;">
                        <button class="ms-2" style="height: min-content;">
                            <img src="@\assets\images\correctionButton.svg" alt="edit button">
                        </button>
                        <button class="ms-2" style="height: min-content;">
                            <img src="@/assets/images/tableDeleteButton.svg" alt="delete button">
                        </button>
                        </div>
                    </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <vue-awesome-paginate
          :total-items="taskWorkersPagingInfo.total"
          :items-per-page="taskWorkersPagingInfo.limit"
          :max-pages-shown="4"
          v-model="taskWorkersPagingInfo.offset"
          :hide-prev-next-when-ends="true"
          @click="taskWorkersPaginationClickHandler"
          class="my-4"
        />
      </div>
    </section>
</div>
</template>
<script>
import primaryButtonComponent from '@/components/primaryButtonComponent.vue';
import secondaryButton from '@/components/secondaryButton.vue';
import excelFileDownloadComponent from '@/components/excelFileDownloadComponent.vue';
import Multiselect from '@vueform/multiselect';
import datePicker from '@/components/datePicker.vue';
import autoSubmittedInput from '@/components/autoSubmittedInput.vue';
export default {
    data(){
        return {
            activatedFilterMode: 0,
            filteringPagingInfo: {
                taskWorkerssearch: null,
                taskWorkerscityID: null,
                taskWorkersregionID: null,
                taskWorkersdistrictID: null,
                taskWorkersstartDateInputValue: null,
                taskWorkersendDateInputValue: null,
                taskWorkersOffset: null,
                taskssearch: null,
                taskstype: null,
                taskspriority: null,
            },
            tasksFiltersInfoObj: {
                search: null,
                type: null,
                priority: null,
            },
            taskWorkersFiltersInfoObj: {
                search: null,
                cityID: null,
                regionID: null,
                districtID: null,
                date: [],
                startDateInputValue: null,
                endDateInputValue: null,
            },
            taskTypesGetterButtonsArray: [
                {
                    content: "ინდივიდუალური",
                    mode: 1,
                    routeSetValue: 1,
                },
                {
                    content: "გუნდური",
                    mode: 1,
                    routeSetValue: 2,
                }
            ],
            taskPrioritiesGetterButtonsArray: [
                {
                    content: "High priority",
                    mode: 1,
                    routeSetValue: 1,
                },
                {
                    content: "Low Priority",
                    mode: 1,
                    routeSetValue: 2,
                }
            ],
            taskWorkersFiltersAreaMultiselectArray: [
                {
                    
                },
                {
                    placeholder: "ოლქი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: false,
                },
                {
                    placeholder: "უბანი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
                {
                    placeholder: "უბნის ნომერი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
            ],
            taskWorkersPagingInfo: {
                limit: 10,
                offset: 1,
                total: 57,
            },
        }
    },
    components: {
        primaryButtonComponent,
        secondaryButton,
        excelFileDownloadComponent,
        Multiselect,
        datePicker,
        autoSubmittedInput,
    },
    
    mounted(){
        this.removeAriaHidden();
        this.routerMountMovement(this.$route);
        this.$watch(() => this.taskWorkersFiltersAreaMultiselectArray[1].options, (newOptions, oldOptions) => {
                this.taskWorkersFiltersInfoObj.cityID = this.taskWorkersFiltersInfoObj.cityID;
                
                if(this.taskWorkersFiltersInfoObj.cityID){
                    this.allowNextMultiselect(this.taskWorkersFiltersInfoObj.cityID, 2, false, false, this.taskWorkersFiltersAreaMultiselectArray, this.taskWorkersFiltersInfoObj);
                    
                }
            },
            { deep: true }
        );
        this.$watch(() => this.taskWorkersFiltersAreaMultiselectArray[2].options, (newOptions, oldOptions) => {
                this.taskWorkersFiltersInfoObj.regionID = this.taskWorkersFiltersInfoObj.regionID;
                if(this.taskWorkersFiltersInfoObj.regionID){
                    this.allowNextMultiselect(this.taskWorkersFiltersInfoObj.regionID, 3, false, false, this.taskWorkersFiltersAreaMultiselectArray, this.taskWorkersFiltersInfoObj);
                }
            },
            { deep: true }
        );
        this.$watch(() => this.taskWorkersFiltersAreaMultiselectArray[3].options, (newOptions, oldOptions) => {
                this.taskWorkersFiltersInfoObj.regionID = this.taskWorkersFiltersInfoObj.regionID;
            },
            { deep: true }
        );
    },
    beforeRouteUpdate(to, from, next){
        let isQueriesValid = this.getInfoFromRoute(to);
        if(isQueriesValid){
            if(this.activatedFilterMode == 0){
                this.manageTaskWorkersFilters();
                this.manageTasksFilters();
            }else if(this.activatedFilterMode == 1){
                this.manageTaskWorkersFilters();
            }else if(this.activatedFilterMode == 2){
                this.manageTasksFilters();
            }
            next(true);
        }else{
            next(false);
            this.$helper.showSwal("არასწორი მისამართი", "error", "");
        }
        this.activatedFilterMode = 0;
    },
    methods: {
        routerMountMovement(to){
            let isQueriesValid = this.getInfoFromRoute(to);
            
            if(isQueriesValid){
                this.manageTaskWorkersFilters();
                this.manageTasksFilters();
                this.getCitiesAll([this.taskWorkersFiltersAreaMultiselectArray]);
            }else{
                this.$router.replace(this.$route.path);
                this.$helper.showSwal("არასწორი მისამართი", "error", "");
            }
            this.activatedFilterMode = 0;

        },
        getInfoFromRoute(to){
            Object.keys(this.filteringPagingInfo).forEach((key) => {
                this.filteringPagingInfo[key] = to.query[key]?decodeURIComponent(to.query[key].replace(/%/g, '%25')):null;
            })
            
            let isQueriesValid = Object.keys(this.filteringPagingInfo).every((key) => {
                if(key == "taskWorkerssearch" || key == "taskssearch"){
                    return this.$helper.checkJustOptionalString(this.filteringPagingInfo[key]??"");
                }else if(key == "taskWorkersstartDateInputValue" || key == "taskWorkersendDateInputValue"){
                    return this.$helper.checkDateWithRegex(this.filteringPagingInfo[key]??"");
                }else if(this.filteringPagingInfo[key] == null){
                    return true;
                }else{
                    return this.$helper.checkOptionalNumber(this.filteringPagingInfo[key]);
                }
            });
            
            return isQueriesValid;
        },
        handleDate(modelDate){
            if(modelDate){
                this.taskWorkersFiltersInfoObj.startDateInputValue = modelDate[0]??null;
                if(modelDate.length > 1){
                    this.taskWorkersFiltersInfoObj.endDateInputValue = modelDate[1]??null;
                }else{
                    this.taskWorkersFiltersInfoObj.endDateInputValue = null;
                }
            }else{
                this.taskWorkersFiltersInfoObj.startDateInputValue = null;
                this.taskWorkersFiltersInfoObj.endDateInputValue = null;
            }
            
        },
        submitTaskWorkersFilters(){
            let tempObj = {};
            if(this.$route.query.taskWorkersOffset){
                tempObj.taskWorkersOffset = 0;
            }
            Object.keys(this.taskWorkersFiltersInfoObj).forEach((key) => {
                if((this.taskWorkersFiltersInfoObj[key] || this.taskWorkersFiltersInfoObj[key] === 0) &&  key != "date"){
                    tempObj[`taskWorkers${key}`] = this.taskWorkersFiltersInfoObj[key];
                }
            })
            this.activatedFilterMode = 1;
            let filteredQueries = {};
            Object.keys(this.$route.query).forEach((queryKey) => {
                if(this.taskWorkersFiltersInfoObj.hasOwnProperty(`${queryKey.slice(11)}`) && queryKey.startsWith("taskWorkers")){
                }else{
                    filteredQueries[queryKey] = this.$route.query[queryKey];
                }
            })
            
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...filteredQueries,
                    ...tempObj,
                }
            });
        },
        taskWorkersPaginationClickHandler(value){
            this.activatedFilterMode = 1;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query, 
                    taskWorkersOffset: Number(value) - 1,
                }
            });
        },
        manageTasksFilters(){
            Object.keys(this.tasksFiltersInfoObj).forEach((key) => {
                if(key == "search"){
                    this.tasksFiltersInfoObj[key] = this.filteringPagingInfo[`tasks${key}`];
                
                }else if(this.filteringPagingInfo[`tasks${key}`]){
                
                    this.tasksFiltersInfoObj[key] = Number(this.filteringPagingInfo[`tasks${key}`]);
                }else{
                    this.tasksFiltersInfoObj[key] = this.filteringPagingInfo[`tasks${key}`];
                }
            })
            
            this.tasksFiltersInfoObj.type = this.tasksFiltersInfoObj.type??1;
            this.tasksFiltersInfoObj.priority = this.tasksFiltersInfoObj.priority??1;

            this.getterButtonsManageHandler(this.taskTypesGetterButtonsArray, this.tasksFiltersInfoObj.type);
            this.getterButtonsManageHandler(this.taskPrioritiesGetterButtonsArray, this.tasksFiltersInfoObj.priority);
        },
        manageTaskWorkersFilters(){
            Object.keys(this.taskWorkersFiltersInfoObj).forEach((key) => {
                if(key == "search" || key == "startDateInputValue" || key == "endDateInputValue"){
                    this.taskWorkersFiltersInfoObj[key] = this.filteringPagingInfo[`taskWorkers${key}`];
                
                }else if(key == "date"){

                }else if(this.filteringPagingInfo[`taskWorkers${key}`]){
                
                    this.taskWorkersFiltersInfoObj[key] = Number(this.filteringPagingInfo[`taskWorkers${key}`]);
                }else{
                    this.taskWorkersFiltersInfoObj[key] = this.filteringPagingInfo[`taskWorkers${key}`];
                }
            })

            this.taskWorkersFiltersInfoObj.date = this.taskWorkersFiltersInfoObj.startDateInputValue?[this.taskWorkersFiltersInfoObj.startDateInputValue??null, this.taskWorkersFiltersInfoObj.endDateInputValue??null]:null;
            
            if(!this.taskWorkersFiltersInfoObj.cityID){
                this.blockNextMultiselects(2, this.taskWorkersFiltersAreaMultiselectArray, this.taskWorkersFiltersInfoObj);
            }else if(!this.taskWorkersFiltersInfoObj.regionID){
                this.blockNextMultiselects(3, this.taskWorkersFiltersAreaMultiselectArray, this.taskWorkersFiltersInfoObj);
            }

            if(this.taskWorkersFiltersInfoObj.cityID){
                this.allowNextMultiselect(this.taskWorkersFiltersInfoObj.cityID, 2, false, false, this.taskWorkersFiltersAreaMultiselectArray, this.taskWorkersFiltersInfoObj);
            }else if(this.taskWorkersFiltersInfoObj.regionID){
                this.allowNextMultiselect(this.taskWorkersFiltersInfoObj.cityID, 3, false, false, this.taskWorkersFiltersAreaMultiselectArray, this.taskWorkersFiltersInfoObj);
            }
            
            this.taskWorkersPagingInfo.offset = this.filteringPagingInfo.taskWorkersOffset?Number(this.filteringPagingInfo.taskWorkersOffset) + 1:1;
            
            // this.getRespodent();
            // this.getSupportersInfo();
        },
        getCitiesAll(changingArray){
            this.$store.dispatch("getCitiesAll").then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.cityID,
                        label: {
                            ge: `${obj.city} ${obj.pathID?`- ${obj.pathID}`:""}`,
                            en: `${obj.cityeng} ${obj.pathID?`- ${obj.pathID}`:""}`,
                        },
                    });
                }
                changingArray.forEach((destArray) => {
                    destArray[1].options = tempArray;
                    destArray[1].isDisabled = false;
                })
            })
        },
        allowNextMultiselect(value, index, clear, blockNext, changingArray, filterVModelsArray){
            if(value){
                if(index == 1){
                    this.getCities(value, clear, changingArray, filterVModelsArray);
                }else if(index == 2){
                    this.getRegions(value, clear, changingArray, filterVModelsArray);
                }else if(index == 3){
                    this.getDistricts(value, clear, changingArray, filterVModelsArray);
                }
            }
            
            if(index < changingArray.length - 1 && blockNext){
                this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
            }

        },
        blockNextMultiselects(index, changingArray, filterVModelsArray){
            
            if(index >= changingArray.length){
                return;
            }
            
            changingArray[index].options = [];
            if(index == 1){
                filterVModelsArray.cityID = null;
                this.getCitiesAll([this.taskWorkersFiltersAreaMultiselectArray]);
            }else if(index == 2){
                filterVModelsArray.regionID = null;
                changingArray[index].isDisabled = true;
            }else if(index == 3){
                filterVModelsArray.districtID = null;
                changingArray[index].isDisabled = true;
            }
            this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);

        },
        getRegions(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getRegions",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.regionID,
                        label: {
                            ge: `${obj.region} ${obj.pathID?`- ${obj.pathID}`:""}`,
                            en: `${obj.regioneng} ${obj.pathID?`- ${obj.pathID}`:""}`,
                        },
                    });
                }
                if(clear){
                    filterVModelsArray.regionID = null;
                }
                changingArray[2].options = tempArray;
                changingArray[2].isDisabled = false;
            })
        },
        getDistricts(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getDistricts",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.districtID,
                        label: {
                            ge: obj.district,
                            en: obj.district,
                        },
                    });
                }
                if(clear){
                    filterVModelsArray.districtID = null;
                }
                changingArray[3].options = tempArray;
                changingArray[3].isDisabled = false;
            })
        },
        updateTasksSearch(value){
            this.activatedFilterMode = 2;
            let obj = {...this.$route.query};
            if(value){
                obj.taskssearch = value;
            }else{
                delete obj.taskssearch;
            }
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...obj,
                    tasksOffset: 0,
                }
            });
        },
        getterButtonsSubmitHandler(submitObj){
            this.activatedFilterMode = 2;
            this.$router.push({
                path: this.$route.path,
                query: {
                ...this.$route.query,
                    ...submitObj,
                    tasksOffset: 0,
                },
            });
        },
        getterButtonsManageHandler(getterButtonsArray, choosenSetValue){
            getterButtonsArray.forEach((element, index) => {
                if(element.routeSetValue == choosenSetValue){
                    element.mode = 0;
                }else{
                    element.mode = 1;
                }
            })
        },
        removeAriaHidden(){
            Array.from(document.querySelectorAll('span.multiselect-clear')).forEach((item) => {
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('aria-hidden');

            })
            
            Array.from(document.querySelectorAll('.multiselect span[aria-hidden]')).forEach((item) => {
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('aria-hidden');

            })
            Array.from(document.querySelectorAll('.multiselect .multiselect-search[aria-labelledby]')).forEach((item) => {
                item.removeAttribute('aria-labelledby');
            })
        },
    }
}
</script>
<style scoped lang="scss">
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(1, min-content);
  row-gap: 2em;
}
.custom-tasks-primary-search-container-form{
    width: 100%;
    display: grid;
    grid-template-columns: 30% auto auto;
    grid-template-rows: 1fr;
    grid-gap: 1em;
    place-items: center;
    .primary-input{
        max-width: none;
    }
}
</style>